import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { X, MessageSquare } from "lucide-react";
import { api } from "../../../software/api";

const mobileOf = (n) => {
  const d = String(n || "").replace(/\D/g, "");
  if (d.startsWith("614") && d.length === 11) return "0" + d.slice(2);
  return d.startsWith("04") && d.length === 10 ? d : "";
};

export function clientMobiles(c) {
  const raw = [c.phone, ...(c.phones || []), ...(c.contact_numbers || []).map((n) => n.number), ...(c.contacts || []).map((x) => x.mobile)];
  return [...new Set(raw.map(mobileOf).filter(Boolean))];
}

// one-off SMS from the client file; the reply nudges whoever sent it
export default function SmsClientModal({ client, onClose }) {
  const nums = clientMobiles(client);
  const [to, setTo] = useState(nums[0] || ""), [text, setText] = useState(""), [busy, setBusy] = useState(false), [ready, setReady] = useState(null);
  useEffect(() => { api("GET", "/sms/ready").then((d) => setReady(d.ready)).catch(() => setReady(false)); }, []);
  const send = async () => {
    setBusy(true);
    try { await api("POST", "/sms/send", { client_id: client.id, to, text }); toast.success(`SMS sent to ${to}`); onClose(); } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  const segs = Math.max(1, Math.ceil(text.length / 160));
  return (
    <div className="fixed inset-0 z-[80] bg-black/50 flex items-center justify-center p-4" onClick={onClose} data-testid="sms-client-modal">
      <div className="bg-white rounded shadow-2xl w-full max-w-md" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-3 py-2 bg-green-700 text-white text-sm font-black"><span className="inline-flex items-center gap-1.5"><MessageSquare className="h-4 w-4" />SMS {client.display_name || client.name}</span><button onClick={onClose} data-testid="sms-client-close"><X className="h-4 w-4" /></button></div>
        <div className="p-3 space-y-2 text-[12.5px]">
          {ready === false && <div className="bg-amber-50 border border-amber-300 text-amber-800 rounded-sm px-2 py-1.5" data-testid="sms-not-ready">SMS isn't switched on yet. The shop's Twilio mobile number still needs adding.</div>}
          <label className="block font-bold text-slate-600">To
            <input list="sms-client-nums" value={to} onChange={(e) => setTo(e.target.value)} placeholder="04xx xxx xxx" data-testid="sms-client-to" className="w-full h-9 border border-slate-300 rounded-sm px-2 font-mono" />
            <datalist id="sms-client-nums">{nums.map((n) => <option key={n} value={n} />)}</datalist>
          </label>
          {!nums.length && <div className="text-[11px] text-slate-500">No mobile number on file. Type one in.</div>}
          <label className="block font-bold text-slate-600">Message
            <textarea value={text} onChange={(e) => setText(e.target.value)} rows={5} maxLength={1000} data-testid="sms-client-text" className="w-full border border-slate-300 rounded-sm p-2 font-normal" placeholder="Hi, it's Glamour Pools and Spas…" />
          </label>
          <div className="flex items-center justify-between text-[11px] text-slate-500"><span data-testid="sms-client-count">{text.length} characters · {segs} SMS</span><span>Replies come back to you.</span></div>
          <div className="flex justify-end gap-2 pt-1">
            <button onClick={onClose} data-testid="sms-client-cancel" className="px-3 py-1.5 border border-slate-300 rounded-sm font-bold">Cancel</button>
            <button onClick={send} disabled={busy || !ready || !text.trim() || !to} data-testid="sms-client-send" className="px-3 py-1.5 rounded-sm bg-green-700 text-white font-bold disabled:opacity-50">{busy ? "Sending…" : "Send SMS"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
